var _style, _defs, _path, _path2, _path3, _g, _defs2, _path4, _path5, _path6, _g2, _defs3, _path7, _g3, _defs4, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g4, _g5, _defs5, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _defs6, _path26, _path27, _path28, _g6, _defs7, _path29, _path30, _path31, _path32, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n\t.st1{clip-path:url(#SVGID_00000016758979299083199220000009499539435339145878_);enable-background:new    ;}\n\t.st2{fill:#363389;}\n\t.st3{fill:#343184;}\n\t.st4{fill:#333080;}\n\t.st5{fill:#3A3692;}\n\t.st6{clip-path:url(#SVGID_00000115500793878066799800000001704213555318580639_);enable-background:new    ;}\n\t.st7{clip-path:url(#SVGID_00000134953103446243041910000017359516511386062240_);enable-background:new    ;}\n\t.st8{fill:#2B286C;}\n\t.st9{fill:#2A276A;}\n\t.st10{clip-path:url(#SVGID_00000183239852758894380410000005158794023018596008_);enable-background:new    ;}\n\t.st11{fill:#2C2A70;}\n\t.st12{fill:#2E2B74;}\n\t.st13{fill:#302D78;}\n\t.st14{fill:#312E7C;}\n\t.st15{fill:#4843B5;}\n\t.st16{clip-path:url(#SVGID_00000177481046725194434800000006552845208269228460_);enable-background:new    ;}\n\t.st17{clip-path:url(#SVGID_00000111910524363615434420000013608875614846748032_);enable-background:new    ;}\n\t.st18{fill:#24225D;}\n\t.st19{fill:#23215A;}\n\t.st20{fill:#222057;}\n\t.st21{fill:#1C1A47;}\n\t.st22{clip-path:url(#SVGID_00000095312559223630944860000012016089032242399371_);enable-background:new    ;}\n\t.st23{fill:#211F55;}\n\t.st24{fill:#232059;}\n\t.st25{fill:#302D7B;}\n\t.st26{fill:#1D1B4C;}\n\t.st27{fill:#716FA2;}\n\t.st28{fill:#525075;}\n\t.st29{fill:#8C89C8;}\n\t.st30{fill:#00DFCE;}\n\t.st31{fill:#008279;}\n\t.st32{fill:#00B4A7;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Icon_awesome-user-alt"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    className: "st0",
    d: "M616.11,583.89l45.59,24.8c-12.94-7.04-28.29-10.01-44.77-7.69l-45.59-24.8 C587.81,573.88,603.17,576.85,616.11,583.89z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000139292090323452884240000006378207989356679351_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139292090323452884240000006378207989356679351_)",
      enableBackground: "new"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M616.92,600.99l-45.59-24.8c10.19-1.43,19.95-0.84,28.97,1.48l45.59,24.8 C636.87,600.15,627.11,599.56,616.92,600.99"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M645.89,602.47l-45.59-24.8c4.62,1.19,9.05,2.83,13.25,4.89l45.59,24.8 C654.94,605.31,650.51,603.66,645.89,602.47"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M659.14,607.37l-45.59-24.8c0.86,0.42,1.71,0.86,2.55,1.32l45.59,24.8 C660.85,608.23,660,607.79,659.14,607.37"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "580.84,606.07 535.26,581.27 571.34,576.2 616.92,600.99  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000063625450550687164400000000536309615430023824_",
    className: "st0",
    d: "M485.39,619.48l-45.59-24.8 c15.13,5.41,31.42,6.89,47.71,4.6c16.29-2.29,32.59-8.35,47.74-18.02l45.59,24.8c-15.15,9.67-31.45,15.73-47.74,18.02 C516.81,626.37,500.52,624.89,485.39,619.48z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000080200716017789805220000003855716271087884198_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000063625450550687164400000000536309615430023824_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000080200716017789805220000003855716271087884198_)",
      enableBackground: "new"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M485.39,619.48l-45.59-24.8c2.68,0.96,5.4,1.8,8.15,2.51l45.59,24.8 C490.79,621.28,488.07,620.44,485.39,619.48"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M493.54,621.99l-45.59-24.8c12.75,3.31,26.15,3.98,39.56,2.09c11.27-1.58,22.54-4.97,33.44-10.11 l45.59,24.8c-10.89,5.14-22.17,8.52-33.44,10.11C519.7,625.96,506.3,625.3,493.54,621.99"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M566.53,613.97l-45.59-24.8c4.86-2.29,9.64-4.93,14.31-7.91l45.59,24.8 C576.17,609.05,571.39,611.68,566.53,613.97"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "449.32,624.55 403.73,599.75 439.8,594.68 485.39,619.48  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000072265618164287244190000015903034215265764773_",
    className: "st0",
    d: "M379.91,764.69l-45.59-24.8 c-8.78-4.78-14.6-14.55-14.59-26.62l45.59,24.8C365.31,750.14,371.13,759.92,379.91,764.69z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000175324018214302492220000006677177239645596578_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000072265618164287244190000015903034215265764773_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000175324018214302492220000006677177239645596578_)",
      enableBackground: "new"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M379.91,764.69l-45.59-24.8c-8.78-4.78-14.6-14.55-14.59-26.62l45.59,24.8 C365.31,750.14,371.13,759.92,379.91,764.69"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "365.33,738.07 319.74,713.27 319.76,701.97 365.35,726.77  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000121995987958582097760000012846993258943949994_",
    className: "st0",
    d: "M365.35,726.77l-45.59-24.8 c0.1-49.96,37.69-95.72,83.97-102.22l45.59,24.8C403.04,631.05,365.45,676.82,365.35,726.77z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000152234411787044805950000004256853934842663821_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000121995987958582097760000012846993258943949994_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000152234411787044805950000004256853934842663821_)",
      enableBackground: "new"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M365.35,726.77l-45.59-24.8c0.02-12.3,2.32-24.34,6.46-35.6l45.59,24.8 C367.67,702.43,365.37,714.48,365.35,726.77"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M371.81,691.17l-45.59-24.8c1.79-4.86,3.91-9.57,6.35-14.1l45.59,24.8 C375.72,681.59,373.59,686.31,371.81,691.17"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M378.15,677.07l-45.59-24.8c2.06-3.83,4.34-7.53,6.83-11.07l45.59,24.8 C382.5,669.53,380.22,673.23,378.15,677.07"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M384.98,665.99l-45.59-24.8c2.34-3.34,4.86-6.54,7.54-9.57l45.59,24.8 C389.84,659.46,387.32,662.65,384.98,665.99"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M392.52,656.42l-45.59-24.8c2.69-3.05,5.55-5.94,8.55-8.64l45.59,24.8 C398.07,650.48,395.22,653.37,392.52,656.42"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M401.07,647.79l-45.59-24.8c3.22-2.9,6.6-5.58,10.13-8.02l45.59,24.8 C407.68,642.21,404.29,644.89,401.07,647.79"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M411.2,639.77l-45.59-24.8c4.33-3,8.88-5.63,13.61-7.85l45.59,24.8 C420.09,634.14,415.54,636.77,411.2,639.77"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M424.82,631.92l-45.59-24.8c7.75-3.64,15.98-6.17,24.5-7.37l45.59,24.8 C440.8,625.75,432.57,628.28,424.82,631.92"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M616.92,600.99c46.29-6.51,83.73,28.72,83.64,78.67l-0.02,11.3c-0.04,18.74-14.14,35.9-31.5,38.34 l-272.35,38.28c-17.35,2.43-31.39-10.78-31.36-29.51l0.02-11.3c0.1-49.96,37.69-95.72,83.97-102.22l36.07-5.07 c15.13,5.41,31.42,6.89,47.71,4.6c16.29-2.29,32.59-8.35,47.74-18.02L616.92,600.99z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M533.16,590.16c-52.06,7.31-94.18-32.32-94.09-88.51c0.11-56.19,42.4-107.68,94.46-114.99 c52.07-7.32,94.19,32.31,94.09,88.5C627.52,531.35,585.23,582.84,533.16,590.16z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000005264606841954032430000008923362442680311968_",
    className: "st0",
    d: "M482.81,581.5l-45.59-24.8 c-26.35-14.33-43.8-43.65-43.74-79.85c0.11-56.19,42.4-107.68,94.46-114.99c18.53-2.6,35.8,0.74,50.36,8.66l45.59,24.8 c-14.56-7.92-31.83-11.26-50.36-8.66c-52.06,7.32-94.35,58.8-94.46,114.99C439.01,537.84,456.47,567.16,482.81,581.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000118397693487153446070000015534203032490097041_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000005264606841954032430000008923362442680311968_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000118397693487153446070000015534203032490097041_)",
      enableBackground: "new"
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M482.81,581.5l-45.59-24.8c-26.35-14.33-43.8-43.65-43.74-79.85c0.03-13.83,2.61-27.37,7.26-40.04 l45.59,24.8c-4.65,12.67-7.24,26.21-7.26,40.04C439.01,537.84,456.47,567.16,482.81,581.5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M446.34,461.6l-45.59-24.8c2.01-5.47,4.4-10.77,7.14-15.87l45.59,24.8 C450.74,450.83,448.35,456.13,446.34,461.6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M453.48,445.73l-45.59-24.8c2.32-4.31,4.89-8.47,7.68-12.46l45.59,24.8 C458.37,437.26,455.8,441.42,453.48,445.73"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M461.16,433.28l-45.59-24.8c2.64-3.76,5.47-7.36,8.49-10.77l45.59,24.8 C466.63,425.92,463.8,429.52,461.16,433.28"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M469.65,422.5l-45.59-24.8c3.03-3.43,6.24-6.68,9.62-9.72l45.59,24.8 C475.89,415.82,472.68,419.07,469.65,422.5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M479.27,412.79l-45.59-24.8c3.62-3.26,7.43-6.28,11.4-9.02l45.59,24.8 C486.7,406.51,482.89,409.53,479.27,412.79"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M490.67,403.77l-45.59-24.8c4.88-3.37,10-6.33,15.31-8.83l45.59,24.8 C500.66,397.43,495.54,400.39,490.67,403.77"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M505.98,394.93l-45.59-24.8c8.72-4.09,17.97-6.94,27.56-8.29c11.46-1.61,22.43-0.95,32.58,1.66l45.59,24.8 c-10.15-2.61-21.12-3.27-32.58-1.66C523.95,388,514.7,390.84,505.98,394.93"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M566.12,388.31l-45.59-24.8c5.2,1.34,10.18,3.19,14.9,5.5l45.59,24.8 C576.3,391.5,571.32,389.65,566.12,388.31"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M581.02,393.82l-45.59-24.8c0.97,0.48,1.93,0.97,2.87,1.49l45.59,24.8 C582.95,394.79,581.99,394.29,581.02,393.82"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Icon_metro-pencil"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000135692335027279861470000017675484921455246482_",
    className: "st0",
    d: "M718.63,333.59l9.12,4.96 c-1.74-0.95-3.81-1.35-6.03-1.04l-9.12-4.96C714.82,332.24,716.89,332.64,718.63,333.59z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000160180833083941759870000010326277367107105681_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000135692335027279861470000017675484921455246482_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000160180833083941759870000010326277367107105681_)",
      enableBackground: "new"
    }
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M721.72,337.51l-9.12-4.96c1.37-0.19,2.68-0.11,3.9,0.2l9.12,4.96 C724.4,337.4,723.09,337.31,721.72,337.51"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M725.62,337.71l-9.12-4.96c0.62,0.16,1.22,0.38,1.79,0.66l9.12,4.96 C726.84,338.09,726.24,337.87,725.62,337.71"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M727.41,338.37l-9.12-4.96c0.12,0.06,0.23,0.12,0.35,0.18l9.12,4.96 C727.64,338.49,727.52,338.43,727.41,338.37"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "711.16,366.74 702.04,361.78 698.15,358.12 707.27,363.08  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000083080434055874036200000012791438735987586739_",
    className: "st0",
    d: "M714.92,340.91l-9.12-4.96 c1.96-1.87,4.35-3.06,6.8-3.4l9.12,4.96C719.27,337.85,716.88,339.04,714.92,340.91z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000039094666918718561190000004046541113450637246_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000083080434055874036200000012791438735987586739_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000039094666918718561190000004046541113450637246_)",
      enableBackground: "new"
    }
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M714.92,340.91l-9.12-4.96c0.1-0.09,0.19-0.18,0.29-0.27l9.12,4.96 C715.11,340.73,715.02,340.82,714.92,340.91"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M715.21,340.64l-9.12-4.96c0.43-0.39,0.89-0.75,1.36-1.07l9.12,4.96 C716.1,339.89,715.64,340.25,715.21,340.64"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M716.57,339.56l-9.12-4.96c0.59-0.41,1.2-0.76,1.83-1.05l9.12,4.96 C717.76,338.81,717.15,339.16,716.57,339.56"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M718.39,338.51l-9.12-4.96c1.07-0.5,2.19-0.85,3.32-1l9.12,4.96 C720.58,337.66,719.46,338.01,718.39,338.51"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "679.42,405.39 670.3,400.43 702.04,361.78 711.16,366.74  "
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M721.72,337.51c6.25-0.87,11.3,3.89,11.29,10.64c0,2.64-0.8,5.32-2.27,7.64l-4.53,5.52l-15.81-14.87 l4.53-5.52C716.88,339.04,719.27,337.85,721.72,337.51z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "726.2,361.3 717.08,356.34 701.27,341.47 710.39,346.43  "
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "710.39,346.43 701.27,341.47 705.8,335.95 714.92,340.91  "
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "660.47,424.26 651.35,419.3 655.92,396.69 665.04,401.65  "
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "665.04,401.65 655.92,396.69 697.86,345.61 706.98,350.57  "
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M665.04,401.65l41.95-51.08l15.81,14.87l-41.95,51.07l-20.38,7.75L665.04,401.65z M711.16,366.74 l-3.89-3.66l-31.74,38.65l3.89,3.66L711.16,366.74"
  })))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st27",
    points: "620.18,335.45 611.06,330.49 632.18,327.52 641.29,332.48  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "608.49,371.3 599.38,366.34 599.42,344.74 608.53,349.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "608.56,337.08 599.44,332.12 599.48,308.22 608.6,313.18  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st27",
    points: "608.6,313.18 599.48,308.22 611.11,306.58 620.22,311.54  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "620.22,311.54 620.18,335.45 641.29,332.48 641.27,345.1 620.16,348.06 620.12,369.67  608.49,371.3 608.53,349.7 587.42,352.67 587.44,340.05 608.56,337.08 608.6,313.18  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "587.42,352.67 578.3,347.71 578.32,335.09 587.44,340.05  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st27",
    points: "587.44,340.05 578.32,335.09 599.44,332.12 608.56,337.08  "
  })))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "717.97,464.72 717.94,478.19 664.09,485.76 664.11,472.29  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "664.09,485.76 654.97,480.8 655,467.33 664.11,472.29  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "664.11,472.29 655,467.33 708.85,459.76 717.97,464.72  "
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.fdf32143ed6707da511bf4fe2c06e007.svg";
export { ForwardRef as ReactComponent };